if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    const summary = details.querySelector('summary');
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);

      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 100);
    });

    summary.addEventListener('click', (e) => {
      const url = summary.dataset.url;

      if (url && url !== '#') {
        e.preventDefault();
        window.location.href = url;
      }
    });
  });
}